module.exports = __webpack_public_path__ + "static/media/notification-icon.b890c552.svg";